<p-inplace
  #inplace
  [disabled]="disabled"
  closable="closable"
  (onDeactivate)="editModeActive.emit(false); resetValue.emit()"
  (onActivate)="editModeActive.emit(true)">
  <ng-template pTemplate="display">
    <div class="w-full px-2 py-1 leading-none">
      <ng-container [ngTemplateOutlet]="viewMode"></ng-container>
    </div>
    <button
      *ngIf="!disabled"
      pButton
      class="p-button-xs p-button-link edit-icon w-min"
      icon="fa-regular fa-pen"></button>
  </ng-template>
  <ng-template pTemplate="content">
    <ng-container [ngTemplateOutlet]="editMode"></ng-container>
    <button
      pButton
      class="p-button-icon-only"
      icon="fa-regular fa-check"
      (click)="editModeActive.emit(false); inplace.active = false; setValue.emit()"></button>
  </ng-template>
</p-inplace>
